import { LocationFlag } from "context/LocationFlagsContext";

interface UpdateLocationFlagsProps {
    apiClient: any;
    locationFlags: LocationFlag[];
    locationId: string;
    partnerId: string;
    posType: string | null | undefined;
}

const updateLocationFlags = async ({
  apiClient,
  locationFlags,
  locationId,
  partnerId,
  posType,
}: UpdateLocationFlagsProps): Promise<any> => {
    if (!locationId || !partnerId || !locationFlags || !posType) {
        throw new Error("Missing required parameters to update location flags.");
    }

    const body = JSON.stringify([ ...locationFlags ]);

    const response = await apiClient.put({
      path: `/middleware-admin/partners/${partnerId}/locations/${locationId}/flags`,
      headers: {
        "Content-Type": "application/json",
        posType,
      },
      body,
      noRetry: true,
    });

    return response.data;
};

export default updateLocationFlags;